exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".healthInfo-nav{\n    display: flex;\n    justify-content: flex-start;\n}\n.account-title{\n    border-bottom: 0.15rem solid #049FDA;\n    margin-right: 2%;\n}\n.account-title-active{\n    background: #049FDA;\n    border-bottom: 0.15rem solid #049FDA;\n    color: #FFF;\n}", ""]);

